module.exports = __webpack_public_path__ + "img/consultor-premium.02f93b48.png";